module.exports = __webpack_public_path__ + "static/media/sarit yerushalmi.f37738eb.jpg";